import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsbutton-group',
	templateUrl:'./BSButtonGroupPluginCompPage.html',
	styles: [],
	styleUrls:['./BSButtonGroupPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSButtonGroupPluginCompPage
{
	mdContent_782 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.groups.BSButtonGroup;
\`\`\``;
	mdContent_783 = `\`\`\`java
BSButtonGroup()
\`\`\``;
	mdContent_784 = `\`\`\`java
BSButtonGroup&lt;?&gt; group = new BSButtonGroup&lt;&gt;();
group.add(new BSButton&lt;&gt;("Left").setPrimary(true));
group.add(new BSButton&lt;&gt;("Right").setPrimary(true));
\`\`\``;
}
